import React, { useCallback, useEffect, useMemo } from 'react'
import { Route, Redirect } from 'react-router-dom'
import { estaLogado } from './login/helper';
import store from './store';
import verificarAcessoProcurador, { buscarPermissaoProcurador, logAgentAttempt } from 'procurador';
import ProcuradorAcessoNegado from 'painel/component/newdashboard/ProcuradorAcessoNegado';
import { useDispatch } from 'react-redux';
import { addToDicionarioPaths, resetBreadcrumb, setBreadcrumb, setTituloPagina } from 'painel/actions';
import { verificarPadraoUrl } from 'shared/helper/utilitarioUrl';

const PrivateRoute = ({ component: Component, path, title, tituloDinamico, breadcrumbProps, ...rest }) => { 

    const dispatch = useDispatch();
    
    const permissoes = useMemo(() => {
        return verificarAcessoProcurador(rest.location.pathname);
    }, [rest.location.pathname])

    const permissao = useMemo(() => {
        return buscarPermissaoProcurador(rest.location.pathname);
    }, [permissoes])

    useEffect(() => {        
        let lastPath = localStorage.getItem("acessoProcurador-lastPath");        
        if (lastPath == null || lastPath != rest.location.pathname){
            if (isProcurador(permissoes)){
                if (logarAcessoProcurador(permissoes)){                 
                    localStorage.setItem("acessoProcurador-lastPath", rest.location.pathname);                    
                    logAgentAttempt(permissoes[0].perfil ? permissoes[0].perfil[0] : 1, permissoes[0].title);//passa 1 so pra evitar nullPointer
                }
            }
        }
    }, [permissoes]);

    useEffect(() => {        
        const { parent = null, enabled = true, skip = false } = breadcrumbProps || {};
        if (!tituloDinamico && !skip) {
            let url = window.location.hash.substring(1).split('?')[0];
            url = verificarPadraoUrl(url, path) ? url : path;
            dispatch(resetBreadcrumb());
            dispatch(setBreadcrumb({ parent, enabled }));
            dispatch(addToDicionarioPaths(url, title));
            dispatch(addToDicionarioPaths(path, title));
            dispatch(setTituloPagina(title));
        }
    }, [rest.location.pathname]);

    const isProcurador = (permissoes) => {        
        return (permissoes != null)
    }
    
    const logarAcessoProcurador = (permissoes) => {        
        return (permissoes?.length > 0 && permissoes[0].log);
    }
  
    const hasPermission = useCallback(() => {
        return (permissoes && permissoes.length == 0) ? false : true;                
    }, [rest.location.pathname])
     
    if(hasPermission()){
        return (
            <Route {...rest} render={(props) => {
                    if (estaLogado() === true) {                                                  
                       
                        return (store.getState().session.usuarioAutorizado === true ?
                        <Component {...props} /> :
                        <Redirect to={'/selo-previdencia'}  /> ) 
                    } else {
                        if (window.location.hash != '#/') {
                            return <Redirect to={{ pathname: '/login', search: `?page=${document.location.hash.substring(1)}` }} />    
                        } else {
                            return <Redirect to='/login' />
                        }
                    }
                }
            } />)
    }else{
        let msg = (permissao ? permissao.msg : '');
        let title = (permissao?.title ? permissao.title : rest.title)        
        return <ProcuradorAcessoNegado title={title} msg={msg}/>
    }

    
};

export default PrivateRoute;
